import Header from './components/Header';
import HeroSection from './components/HeroSection';
import FaqSection from './components/FaqSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import CardsSection from './components/CardsSection';
import CarouselSection from './components/CarouselSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <FaqSection />
        <UpdatesSection />
        <CommentsSection />
        <IndexSection />
        <TopicsSection />
        <FeaturesSection />
        <CardsSection />
        <CarouselSection />
        <MediaSection />
        <AppSection />
        <RankingSection />
        <ContactSection />
        <AboutSection />
      </main>
      <Footer />
    </div>
  );
}